module.exports = __webpack_public_path__ + "img/Melall.68fe4913.svg";